import XLSX from 'xlsx';
import moment from 'moment';

const FAIL_BIN = 8;
const styleCenter = { // 样式不支持,需要用到xlsx的pro版本,要花几百$,但代码还是写着了,据说可以用xlsx-style代替,但是很久没更新了,就作罢
  alignment: {
    vertical: 'center',
    horizontal: 'center',
  }
};
const styleLeft = {
  alignment: {
    vertical: 'center',
    horizontal: 'left',
  }
};

const lotToPackageFactory = {
  F: '通富微电子股份有限公司',
  K: '深圳康姆科技有限公司',
  X: '华天科技（西安）有限公司',
  T: '天水华天科技股份有限公司',
  Q: '气派科技股份有限公司 ',
  M: '四川明泰电子科技有限公司 ',
  W: '西安微电子技术研究所',
  E: '深圳市深视芯科技有限公司',
  G: '广西桂芯半导体科技有限公司 ',
  J: '江阴长电科技股份有限公司 ',
  D: '厦门天微电子有限公司',
  H: '池州华宇电子科技有限公司',
};

function editHeader({sheetData, merges, consignor}) {
  const {
    contactAddr,
    contactPhone,
    contact,
  } = consignor;
  sheetData['A1'] =　{ v: '装箱清单', s: styleCenter };
  merges.push({
    s: { // s为开始
      c: 0,  // 开始列
      r: 0, // 开始行
    },
    e: {
      c: 16,
      r: 0,
    }
  });

  sheetData['A2'] =　{ v: '供应商:', s: styleCenter };
  merges.push({
    s: {
      c: 0,
      r: 1,
    },
    e: {
      c: 1,
      r: 1,
    }
  });
  sheetData['E2'] =　{ v: '绍兴网策科技有限公司', s: styleCenter };
  merges.push({
    s: {
      c: 4,
      r: 1,
    },
    e: {
      c: 16,
      r: 1,
    }
  });

  sheetData['A3'] =　{ v: '地址:', s: styleCenter };
  merges.push({
    s: {
      c: 0,
      r: 2,
    },
    e: {
      c: 1,
      r: 2,
    }
  });
  sheetData['E3'] =　{ v: contactAddr, s: styleCenter };
  merges.push({
    s: {
      c: 4,
      r: 2,
    },
    e: {
      c: 16,
      r: 2,
    }
  });

  sheetData['A4'] =　{ v: '联系人:', s: styleCenter };
  merges.push({
    s: {
      c: 0,
      r: 3,
    },
    e: {
      c: 1,
      r: 3,
    }
  });
  sheetData['E4'] =　{ v: contact, s: styleCenter };
  merges.push({
    s: {
      c: 4,
      r: 3,
    },
    e: {
      c: 8,
      r: 3,
    }
  });
  sheetData['K4'] =　{ v: '联系方式:', s: styleCenter };
  merges.push({
    s: {
      c: 10,
      r: 3,
    },
    e: {
      c: 11,
      r: 3,
    }
  });
  sheetData['M4'] =　{ v: contactPhone, s: styleCenter };
  merges.push({
    s: {
      c: 12,
      r: 3,
    },
    e: {
      c: 16,
      r: 3,
    }
  });
}

function editListTitle({sheetData}) {
  sheetData['A5'] =　{ v: '日期', s: styleCenter };
  sheetData['B5'] =　{ v: '完成产品名', s: styleCenter };
  sheetData['C5'] =　{ v: '封装形式', s: styleCenter };
  sheetData['D5'] =　{ v: '芯片型号', s: styleCenter };
  sheetData['E5'] =　{ v: '封装厂', s: styleCenter };
  sheetData['F5'] =　{ v: '订单号', s: styleCenter };
  sheetData['G5'] =　{ v: '印章批号', s: styleCenter };
  sheetData['H5'] =　{ v: '外箱上标签上的Tracking NO', s: styleCenter };
  sheetData['I5'] =　{ v: '档位', s: styleCenter };
  sheetData['J5'] =　{ v: '合格率', s: styleCenter };
  sheetData['K5'] =　{ v: '合格数', s: styleCenter };
  sheetData['L5'] =　{ v: '不良数', s: styleCenter };
  sheetData['M5'] =　{ v: '箱数', s: styleCenter };
  sheetData['N5'] =　{ v: '收货地址', s: styleCenter };
  sheetData['O5'] =　{ v: '箱号', s: styleCenter };
  sheetData['P5'] =　{ v: '货运方式', s: styleCenter };
  sheetData['Q5'] =　{ v: '汇总', s: styleCenter };
}

function exportInvoiceXlsx({consignor, prodStores, productOrderNo, contactAddr, expressage}) {
  const sheetData = {};
  const merges = [];
  editHeader({ sheetData, merges, consignor});
  editListTitle({ sheetData });
  const baseIndex = 6;
  let index = 0, nowIndex, boxCount = 0, rowspan, startR, endR, lotNo;
  prodStores.map((item) => {
    rowspan = item.rowspan;
    nowIndex = baseIndex + index;
    if (rowspan) {
      boxCount++;
      startR = nowIndex - 1; // -1是因为从0开始计数
      endR = nowIndex - 2 + rowspan;
      merges.push({ // 合并外箱上标签上的Tracking NO
        s: {
          c: 7,
          r: startR,
        },
        e: {
          c: 7,
          r: endR,
        }
      });
      merges.push({ // 合并箱号
        s: {
          c: 14,
          r: startR,
        },
        e: {
          c: 14,
          r: endR,
        }
      });
      merges.push({ // 合并汇总
        s: {
          c: 16,
          r: startR,
        },
        e: {
          c: 16,
          r: endR,
        }
      });
    }
    lotNo = item.lotNo;
    sheetData[`A${nowIndex}`] = { v: moment.utc(item.createAt).local().format('YYYY年M月D日'), s: styleCenter };
    sheetData[`B${nowIndex}`] = { v: item.productName, s: styleCenter };
    sheetData[`C${nowIndex}`] = { v: item.packageType, s: styleCenter };
    sheetData[`D${nowIndex}`] = { v: item.chipName, s: styleCenter };
    sheetData[`E${nowIndex}`] = { v: lotNo && lotNo.length > 0 ? lotToPackageFactory[lotNo[0]] : '', s: styleCenter };
    sheetData[`F${nowIndex}`] = { v: item.incoOrderNo, s: styleCenter };
    sheetData[`G${nowIndex}`] = { v: lotNo, s: styleCenter };
    sheetData[`H${nowIndex}`] = { v: item.boxNo, s: styleCenter };
    sheetData[`I${nowIndex}`] = { v: item.binLevelVal, s: styleCenter };
    sheetData[`J${nowIndex}`] = { v: '', s: styleCenter };
    sheetData[`K${nowIndex}`] = { v: item.binLevel !== FAIL_BIN ? item.count : '', s: styleCenter };
    sheetData[`L${nowIndex}`] = { v: item.binLevel === FAIL_BIN ? item.count : '', s: styleCenter };
    sheetData[`M${nowIndex}`] = { v: '', s: styleCenter };
    sheetData[`N${nowIndex}`] = { v: contactAddr, s: styleCenter };
    sheetData[`O${nowIndex}`] = { v: boxCount, s: styleCenter };
    sheetData[`P${nowIndex}`] = { v: expressage, s: styleCenter };
    sheetData[`Q${nowIndex}`] = { v: item.allCount, s: styleCenter };
    index++;
  });

  sheetData[`M${baseIndex}`] = { v: `共${boxCount}箱`, s: styleCenter };
  merges.push({ // 合并箱数
    s: {
      c: 12,
      r: baseIndex - 1,  // -1是因为从0开始计数
    },
    e: {
      c: 12,
      r: baseIndex + index - 2,
    }
  });

  merges.push({ // 合并收货地址
    s: {
      c: 13,
      r: baseIndex - 1,
    },
    e: {
      c: 13,
      r: baseIndex + index - 2,
    }
  });

  merges.push({ // 合并货运模式
    s: {
      c: 15,
      r: baseIndex - 1,
    },
    e: {
      c: 15,
      r: baseIndex + index - 2,
    }
  });

  sheetData['!merges'] = merges;
  sheetData['!ref'] = `A1:Q${baseIndex + index - 1}`;
  sheetData["!cols"] = [{
    wch: 15, // 单元格列的宽度
  }, {
    wch: 12,
  }, {
    wch: 15,
  }, {
    wch: 12,
  }, {
    wch: 12,
  }, {
    wch: 12,
  },{
    wch: 12,
  }, {
    wch: 25,
  }, {
    wch: 8,
  }, {
    wch: 8,
  }, {
    wch: 8,
  }, {
    wch: 8,
  }, {
    wch: 8,
  }, {
    wch: 8,
  }, {
    wch: 8,
  }, {
    wch: 8,
  }];
  const sheetName = 'Sheet1';
  const wb = { SheetNames: [`${sheetName}`], Sheets: {} };
  wb.Sheets[`${sheetName}`] = sheetData;
  // return;
  XLSX.writeFile(wb, `${productOrderNo || Date.now()}.xlsx`);
}

export default exportInvoiceXlsx;
